import React from 'react'
import { useGenerateContent } from './helpers/useGenerateContent'
import { TEXT_PROPS } from './interface'
import TextContainer from './TextContainer'

function Text({
  ante,
  state,
  playerWinType,
  currency,
  totalWin,
  isFold,
  precision
}: TEXT_PROPS) {
  const [content, fadeIn] = useGenerateContent(
    ante,
    state,
    playerWinType,
    currency,
    totalWin,
    isFold,
    precision
  )
  return <TextContainer fadeIn={fadeIn}>{content}</TextContainer>
}

export default Text
